module.exports = __webpack_public_path__ + "media/feature-icons/Mobile_Payments-192b1671.svg";